import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { TblLogsUser, TblLogsYS, headTbl } from '../../../data/tables';
import LoadinSpin from '../../ui/LoadinSpin';
import { useShowColums, useShowColumsHook } from '../../../hooks/useShowColums';
import moment from 'moment';
import { useGetDta } from '../../../hooks/useGetDta';
import Table from '../../Table';
import DropDownsCol from '../../ui/DropDownsCol';
import CuatroColumn from '../../settings/CuatroColum';
import { getInitialColumns } from '../../../data/cards';  

const LogsUs = ({ activeTab }) => {
    const { id } = useParams();

    let idR = atob(id);

    const initialColums = getInitialColumns('logsus', TblLogsUser);
    const { toggleCheck, columnasVisibles } = useShowColumsHook(initialColums, 'logsus');

    const { loading, data, getInfo } = useGetDta(`usertools/logsus`, { id: idR }, 'PUT');
    useEffect(() => {
        getInfo(`usertools/logsus`, { id: idR }, 'PUT');
    }, [idR, activeTab]);
    const ActionColumn = ({ row }) => {
        return <>{moment(row.original.fecha).format('YYYY-MM-DD HH:mm:ss')}</>;
    };
    const InfoColumn = ({ row }) => {
        return <span style={{whiteSpace:'pre-line'}}>{row.original.tres}</span>;
    };
    const columns = [
        {
            Header: 'Fecha',
            accessor: 'fecha',
            sort: true,
            Cell: ActionColumn,
        },

        {
            Header: 'Detalle',
            accessor: 'tres',
            sort: true,
            Cell:InfoColumn
        },
        {
            Header: 'Data',
            accessor: 'cuatro',
            sort: true,
            Cell:CuatroColumn
        },
        {
            Header: 'Agente',
            accessor: 'dos',
            sort: true,
        },
    ];
    const sizePerPageList = headTbl(data.length);
    if (loading) return <LoadinSpin />;

    return (
        <div className="mt-3">
            {' '}
            <Row className="mb-2 ">
                <Col>
                    <DropDownsCol
                        cols={columnasVisibles} // Pasar el estado desde TblZonas
                        toggleCheck={toggleCheck} // Pasar la función de toggleCheck desde TblZonas
                    />
                </Col>
            </Row>
            <Table
                columns={columns}
                data={data}
                pageSize={25}
                sizePerPageList={sizePerPageList}
                isSortable={true}
                pagination={true}
                columnasVisibles={columnasVisibles}
                isSearchable={true}
                searchBoxClass="mb-2"
            />
        </div>
    );
};
export default LogsUs;
